// framework/common/schemas/collections/workflowInstances.js
import { z } from "zod";

const WorkflowInstanceSchema = z.object({
    _id: z.string().optional().describe("MongoDB ObjectId"),
    instanceId: z.string().describe("The unique identifier for this running instance (e.g., a conversationId)."),
    workflowId: z.string().describe("The _id of the workflow definition being executed."),
    status: z.enum(['running', 'waiting_for_input', 'completed', 'failed']).default('running'),
    
    // State persistence
    dataStore: z.record(z.any()).default({}).describe("The in-memory data store of the workflow."),
    waitingForInputOnToolId: z.string().optional().nullable().describe("The instanceId of the tool that is currently waiting for user input."),
    
    // Context of the execution
    context: z.record(z.any()).optional().describe("The context the workflow was started with (userId, projectId, etc.)."),
    workflowArgs: z.record(z.any()).optional().describe("The initial arguments passed to the workflow."),

    createdAt: z.coerce.date().optional(),
    updatedAt: z.coerce.date().optional(),
});

export default WorkflowInstanceSchema;